(function () {
  'use strict';

  // Lowercase + strip Polish diacritics so "Łopian" matches letter "L" and query "lopian".
  function normalize(value) {
    return (value || '')
      .toString()
      .toLowerCase()
      .replace(/ł/g, 'l')
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '');
  }

  function initBlogSearch(root) {
    if (!root || root.dataset.blogSearchReady === 'true') return;

    var input = root.querySelector('[data-search-input]');
    var letterButtons = Array.prototype.slice.call(root.querySelectorAll('[data-letter]'));
    var grid = root.querySelector('[data-results-grid]');
    var emptyState = root.querySelector('[data-empty]');
    var pagination = root.querySelector('[data-pagination]');
    var pageList = root.querySelector('[data-pagination-list]');
    var nextButton = root.querySelector('[data-pagination-next]');
    var resultsAnchor = root.querySelector('.blog-search-results');
    var perPage = parseInt(root.getAttribute('data-per-page'), 10) || 12;

    if (!grid) return;

    var cards = Array.prototype.slice.call(grid.querySelectorAll('.blog-search-card'));
    if (!cards.length) return;

    var items = cards.map(function (card) {
      var title = normalize(card.getAttribute('data-title'));
      var latin = normalize(card.getAttribute('data-latin'));
      return {
        el: card,
        haystack: (title + ' ' + latin).trim(),
        letter: (title.charAt(0) || '').toUpperCase()
      };
    });

    var availableLetters = {};
    items.forEach(function (item) {
      if (item.letter) availableLetters[item.letter] = true;
    });

    letterButtons.forEach(function (button) {
      var letter = (button.getAttribute('data-letter') || '').toUpperCase();
      if (!availableLetters[letter]) {
        button.disabled = true;
        button.classList.add('blog-search-filters__letter--disabled');
      }
    });

    var state = { query: '', letter: null, page: 1 };

    function getFiltered() {
      var query = normalize(state.query).trim();
      return items.filter(function (item) {
        var matchesQuery = !query || item.haystack.indexOf(query) !== -1;
        var matchesLetter = !state.letter || item.letter === state.letter;
        return matchesQuery && matchesLetter;
      });
    }

    function scrollToResults() {
      if (resultsAnchor && typeof resultsAnchor.scrollIntoView === 'function') {
        resultsAnchor.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }

    function renderPagination(totalPages) {
      if (!pagination || !pageList) return;

      pageList.innerHTML = '';

      if (totalPages <= 1) {
        pagination.hidden = true;
        return;
      }

      pagination.hidden = false;

      for (var page = 1; page <= totalPages; page++) {
        var listItem = document.createElement('li');

        if (page === state.page) {
          var current = document.createElement('span');
          current.className = 'blog-search-results__pagination-current body-semibold-l';
          current.setAttribute('aria-current', 'page');
          current.textContent = page;
          listItem.appendChild(current);
        } else {
          var link = document.createElement('button');
          link.type = 'button';
          link.className = 'blog-search-results__pagination-link body-regular-l';
          link.textContent = page;
          link.addEventListener('click', goToPage.bind(null, page));
          listItem.appendChild(link);
        }

        pageList.appendChild(listItem);
      }

      if (nextButton) nextButton.disabled = state.page >= totalPages;
    }

    function render() {
      var filtered = getFiltered();
      var totalPages = Math.max(1, Math.ceil(filtered.length / perPage));

      if (state.page > totalPages) state.page = totalPages;

      var start = (state.page - 1) * perPage;
      var end = start + perPage;

      items.forEach(function (item) {
        item.el.style.display = 'none';
      });
      filtered.slice(start, end).forEach(function (item) {
        item.el.style.display = '';
      });

      if (emptyState) emptyState.hidden = filtered.length !== 0;

      renderPagination(totalPages);
    }

    function goToPage(page) {
      state.page = page;
      render();
      scrollToResults();
    }

    if (input) {
      input.addEventListener('input', function () {
        state.query = input.value;
        state.page = 1;
        render();
      });

      var form = input.closest('form');
      if (form) {
        form.addEventListener('submit', function (event) {
          event.preventDefault();
        });
      }
    }

    letterButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        if (button.disabled) return;

        var letter = (button.getAttribute('data-letter') || '').toUpperCase();

        if (state.letter === letter) {
          state.letter = null;
          button.classList.remove('blog-search-filters__letter--active');
          button.setAttribute('aria-pressed', 'false');
        } else {
          letterButtons.forEach(function (other) {
            other.classList.remove('blog-search-filters__letter--active');
            other.setAttribute('aria-pressed', 'false');
          });
          state.letter = letter;
          button.classList.add('blog-search-filters__letter--active');
          button.setAttribute('aria-pressed', 'true');
        }

        state.page = 1;
        render();
      });
    });

    if (nextButton) {
      nextButton.addEventListener('click', function () {
        var totalPages = Math.max(1, Math.ceil(getFiltered().length / perPage));
        if (state.page < totalPages) goToPage(state.page + 1);
      });
    }

    root.dataset.blogSearchReady = 'true';
    render();
  }

  function initAll() {
    var roots = document.querySelectorAll('[data-blog-search]');
    Array.prototype.forEach.call(roots, initBlogSearch);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Re-init inside the Shopify theme editor.
  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-blog-search]');
    if (root) {
      root.dataset.blogSearchReady = '';
      initBlogSearch(root);
    }
  });
})();
